import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ContentHeaderHTML, ContentHeaderTitle } from "src/app/constants/content-header";
import { InPageNavItem } from "src/app/models/in-page-nav";
import { HelperService } from "src/app/services/helper.service";
import { NavigationService } from "src/app/services/navigation.service";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: 'mwp-card-content-header',
    templateUrl: './card-content-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardContentHeader implements OnInit {
    @Input() url: string;
    @Input() callService: boolean = true;
    @Input() public contentTitleMwp: string;
    @Input() public text: string;

    public title: string;
    public titleJsonKey: string;
    public headerHTML: string;
    public headerHTMLJsonKey: string;
    public navItems: InPageNavItem[];

    constructor(
        private helperService: HelperService,
        private navService: NavigationService,
        private router: Router,
        private session: SessionService
    ) {
    }

    ngOnInit(): void {
        if (this.session.session.isMember)
            this.navItems = this.navService.buildMemberPageNavItems(this.router.url);
        else if (this.session.session.isAgent)
            this.navItems = this.navService.buildAgentPageNavItems(this.router.url);
        
        if (this.url) {
            this.titleJsonKey = 'contentHeader' + this.url;
            this.title = ContentHeaderTitle[this.titleJsonKey as keyof typeof ContentHeaderTitle];
            this.headerHTMLJsonKey = 'contentHeaderHTML' + this.url;
            this.headerHTML = ContentHeaderHTML[this.headerHTMLJsonKey as keyof typeof ContentHeaderHTML];
        } else {
            this.title = this.contentTitleMwp;
            this.titleJsonKey = this.helperService.camelCase(this.contentTitleMwp);
        }
        
    }
}
